import { FieldProps } from 'formik';
import { useCallback } from 'react';
import { FormControlLabel, FormControlLabelProps } from '@mui/material';
import { ColorPicker, IColorPickerProps } from '@shared/components/ColorPicker';
import { ColorPickerFieldLabel } from '@styles/InputStyles';

export interface IColorPickerFieldProps extends FieldProps, IColorPickerProps {
  disabled?: boolean;
  onChange(color: string, name?: string): void;
  labelPlacement: FormControlLabelProps['labelPlacement'];
  wrap?: boolean;
  label?: string;
}

export const ColorPickerField = ({ field, form: _form, disabled: _disabled, ...props }: IColorPickerFieldProps) => {
  const handleChange = useCallback(
    (color: string) => {
      field.onChange({
        target: {
          name: field.name,
          value: color,
        },
      });

      props.onChange?.(color, field.name);
    },
    [field, props],
  );

  return (
    <FormControlLabel
      label={<ColorPickerFieldLabel wrap={props?.wrap}>{props?.label}</ColorPickerFieldLabel>}
      labelPlacement={props?.labelPlacement || 'start'}
      sx={{ marginLeft: '10px' }}
      control={<ColorPicker {...field} {...props} color={field.value} onChange={handleChange} />}
    />
  );
};
